// Package imports
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { FormControl } from "@mui/material";
import moment from "moment";

// Custom imports
import { getFormatedDateTime } from "../../Js/TimeAndDate";

// Global variables

// Component
const WwDatePicker = (props) => {
  const classes = useStyles();

  // State
  const [date, setDate] = useState(props.defaultDate);

  // React logic hooks
  useEffect(() => {
    if (props.defaultDate) {
      props.dateChange({
        date: getFormatedDateTime(props.defaultDate),
        valid: true,
        errorMessage: null,
      });
    }
    setDate(props.defaultDate);
  }, [props.defaultDate]);

  // On click open date picker
  const showDatePicker = () => {
    if (!date) {
      setDate(Date());
      props.dateChange({
        date: getFormatedDateTime(Date()),
        valid: true,
        errorMessage: null,
      });
    }
  };

  // After date selection to reflect selected date
  const handleChange = (date) => {
    console.log("444444", date);
    let dateObj = new Date(date._d);
    if (
      props.toTime &&
      +dateObj.getHours() == 0 &&
      +dateObj.getMinutes() == 0
    ) {
      dateObj.setHours(23);
      dateObj.setMinutes(0);
      dateObj.setSeconds(0);
    }
    let updatedDate = moment(dateObj);
    setDate(dateObj.toString());
    let { valid, errorMessage } = validateDate(getFormatedDateTime(updatedDate));
    props.dateChange({
      date: getFormatedDateTime(updatedDate),
      valid,
      errorMessage,
    });
  };

  // validate selected dates
  const validateDate = (selectedDate) => {
    let dateObj = new Date(selectedDate);
    console.log("dateObj", dateObj);
    console.log("dateObjMin", new Date(props.minDate));
    if (props.minDate) {
      let dateObjMin = new Date(props.minDate);
      if (dateObj.getTime() < dateObjMin.getTime()) {
        return {
          valid: false,
          errorMessage:
            "Selected Date must be greater than " +
            getFormatedDateTime(props.minDate),
        };
      } else {
        return {
          valid: true,
          errorMessage: null,
        };
      }
    } else if (props.maxDate) {
      let dateObjMin = new Date(props.maxDate);
      if (dateObj.getTime() > dateObjMin.getTime()) {
        return {
          valid: false,
          errorMessage:
            "Selected date must be either the current date or prior to that. " +
            getFormatedDateTime(props.maxDate),
        };
      } else {
        return {
          valid: true,
          errorMessage: null,
        };
      }
    }
  };

  // JSX template
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} def>
      <FormControl
        fullWidth
        sx={{
          mx: 1,
          mb: 1,
          borderRadius: 2,
          borderColor: "#FFFFFF",
          backgroundColor: "#F5F5F5",
          color: "#D9D9D9",
        }}
        size="small"
      >
        {!props.withTime && (
          <DatePicker
            timezone="Asia/Kolkata"
            label={props.placeholder}
            onChange={handleChange}
            className={classes.container}
            value={moment(date)}
            disabled={props.disabled != undefined ? props.disabled : false}
            slotProps={{
              textField: {
                error: false,
              },
            }}
          />
        )}
        {props.withTime && (
          <DateTimePicker
            timezone="Asia/Kolkata"
            label={props.placeholder}
            onChange={handleChange}
            className={classes.container}
            value={moment(date)}
            disabled={props.disabled != undefined ? props.disabled : false}
            slotProps={{
              textField: {
                error: false,
              },
            }}
          />
        )}
      </FormControl>
    </LocalizationProvider>
  );
};

const useStyles = makeStyles({
  container: {
    mx: 1,
    mb: 1,
    borderRadius: "50px",
    border: 1,
    backgroundColor: "#F5F5F5",
    borderColor: "#A9A9A9",
    fontWeight: "500",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
});

export default WwDatePicker;
